export const TYPES_SCHOOL_YEAR = {
  CONFIGURE: 'CONFIGURE_SCHOOL_YEAR',
  ENDING: 'ENDING_SCHOOL_YEAR',
  SCHOOL_YEAR_IN_PROGRESS: 'SCHOOL_YEAR_IN_PROGRESS',
}

export const TYPES_STEPS = {
  EMPTY: '',
  NO_CLASSROOM: 'NO_CLASSROOM',
  NO_COURSE: 'NO_COURSE',
  NO_SCHOOL: 'NO_SCHOOL',
}
